import {
  DocxException,
  createParagraph,
  createEmptyLine,
  createBoldParagraph,
  createSeparateParagraphs,
} from '../docxFunctions'
import { createCharacteristics } from '@/components/reportPresentation/allTables/createCharacteristicsTable'
import {
  BOLD_TEXT,
  DEFAULT_TEXT,
  ITALIC_TEXT,
  createCombinationParagraph,
  createCombinationParagraphWithCenter,
} from '../docxFunctions'
import { createNumberedSectionHeading } from '@/components/reportPresentation/presentationSectionHeading'
import { createCrPresenceDocxBlocks } from '@/components/reportPresentation/crPresenceDocx'
import { createCostAndGoPricingDocxBlocks } from '@/components/reportPresentation/costGoPricingDocx'
import { createAssessmentPresentationBlocks } from '@/components/reportPresentation/assessmentPresentationDocx'

function buildListLabel(summary) {
  const listArr = []
  if (summary?.gnvlp) listArr.push('ЖНВЛП')
  if (summary?.vzn14) listArr.push('ВЗН14')
  return listArr.join(', ')
}

function manufacturerBlocks(summary) {
  const blocks = []
  const raw = String(summary?.manufacturer || '').trim()
  if (!raw) return blocks

  blocks.push(
    createCombinationParagraph([
      { type: BOLD_TEXT, content: 'Производитель: ' },
      { type: DEFAULT_TEXT, content: '' },
    ])
  )

  const parts = raw.split(/\n\n+/)
  parts.forEach((part, idx) => {
    const lines = part.split('\n').filter(l => l.trim())
    if (!lines.length) return
    if (idx === 0 && lines.length === 1) {
      blocks[blocks.length - 1] = createCombinationParagraph([
        { type: BOLD_TEXT, content: 'Производитель: ' },
        { type: DEFAULT_TEXT, content: lines[0] },
      ])
    } else if (idx === 0) {
      blocks.pop()
      blocks.push(
        createCombinationParagraph([
          { type: BOLD_TEXT, content: 'Производитель: ' },
          { type: DEFAULT_TEXT, content: lines[0] },
        ])
      )
      lines.slice(1).forEach(line => {
        blocks.push(createParagraph(line, {}, {}, 24))
      })
    } else {
      lines.forEach((line, lineIdx) => {
        const isContract =
          line.toLowerCase().includes('договор') ||
          line.toLowerCase().includes('контрактн') ||
          line.toLowerCase().includes('представлен')
        if (isContract) {
          blocks.push(
            createCombinationParagraph([{ type: ITALIC_TEXT, content: line }])
          )
        } else {
          blocks.push(createParagraph(line, {}, {}, 24))
        }
      })
    }
  })

  return blocks
}

export function createOneChapter(summary, cost, goPricing, context = {}) {
  try {
    const list = buildListLabel(summary)
    const hasGoPricing = !!goPricing?.pricingRows?.length

    const documentTitle = [
      createCombinationParagraphWithCenter([
        {
          type: BOLD_TEXT,
          content: summary.mnn || 'МНН',
          size: 32,
        },
      ]),
      ...(list
        ? [
            createCombinationParagraphWithCenter([
              {
                type: BOLD_TEXT,
                content: `(вкл. в ${list})`,
                size: 32,
              },
            ]),
          ]
        : []),
      createEmptyLine(),
      createNumberedSectionHeading(1, 'ОБЩАЯ ИНФОРМАЦИЯ'),
      createEmptyLine(),
    ]

    return [
      ...documentTitle,
      createCombinationParagraph([
        { type: BOLD_TEXT, content: 'Лекарственная форма: ' },
        { type: DEFAULT_TEXT, content: summary.lForma || '' },
      ]),
      createCombinationParagraph([
        { type: BOLD_TEXT, content: 'Дата регистрации ЛП: ' },
        { type: DEFAULT_TEXT, content: summary.ruDate || '' },
      ]),
      createCombinationParagraph([
        { type: BOLD_TEXT, content: 'Предыдущие предложения: ' },
        {
          type: DEFAULT_TEXT,
          content: summary.previousProposalSubmitted
            ? summary.previousProposalText || ''
            : 'Нет',
        },
      ]),
      ...manufacturerBlocks(summary),
      createCombinationParagraph([
        { type: BOLD_TEXT, content: 'Держатель РУ: ' },
        { type: DEFAULT_TEXT, content: summary.ruHolder || '' },
      ]),
      createCombinationParagraph([
        { type: BOLD_TEXT, content: 'Орфанный статус: ' },
        {
          type: DEFAULT_TEXT,
          content: summary.isOrphan ? 'да' : 'нет',
        },
      ]),
      createBoldParagraph(
        'Заявленные показания к применению лекарственного препарата:'
      ),
      ...createSeparateParagraphs(summary.condition || '—'),
      ...createCrPresenceDocxBlocks(summary.crPresence, summary.crNames),
      ...(summary.inCriticalIndustrialProductList
        ? [
            createCombinationParagraph([
              {
                type: BOLD_TEXT,
                content:
                  'Наличие в перечне критической промышленной продукции в отрасли фарм. промышленности: ',
              },
              { type: DEFAULT_TEXT, content: 'да' },
            ]),
          ]
        : []),
      ...createCostAndGoPricingDocxBlocks(cost, goPricing),
      ...(!hasGoPricing && summary.priceCharacteristics?.length
        ? [
            createCombinationParagraph([
              { type: BOLD_TEXT, content: 'Ценовая характеристика ЛП' },
            ]),
            createCharacteristics(summary.priceCharacteristics),
          ]
        : []),
      ...createAssessmentPresentationBlocks(summary, {
        otherExpertise: context.other,
        plpRegionText: context.plpRegionText,
        listLabel: list,
        assessmentEp: context.assessment,
      }),
    ]
  } catch (err) {
    throw new DocxException(1, err.message)
  }
}
